import { render, staticRenderFns } from "./nav-only.vue?vue&type=template&id=e2d97c88&scoped=true&lang=pug"
import script from "./nav-only.vue?vue&type=script&lang=ts"
export * from "./nav-only.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d97c88",
  null
  
)

export default component.exports